// src/components/job-engine/PayloadViewer.tsx
import React from "react";
import JsonView from "@uiw/react-json-view";
import { Text } from "@fluentui/react";

interface Props {
  value: unknown;
  maxHeight?: number;
}

const PayloadViewer: React.FC<Props> = ({ value, maxHeight = 360 }) => {
  if (value === undefined || value === null) {
    return <Text variant="small" styles={{ root: { fontStyle: "italic", color: "#8a8886" } }}>No payload</Text>;
  }
  return (
    <div style={{ maxHeight, overflow: "auto", border: "1px solid #edebe9", borderRadius: 4, padding: 8 }}>
      <JsonView value={value as object} collapsed={2} displayDataTypes={false} />
    </div>
  );
};

export default PayloadViewer;
